import { DISCIPLINE_IDS, getDiscipline, normalizeDiscipline } from "@/lib/trainingDisciplines";

export default function DisciplinePicker({ value, onChange, disabled = false }) {
  const selected = normalizeDiscipline(value);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5" data-testid="discipline-picker">
      {DISCIPLINE_IDS.map((id) => {
        const d = getDiscipline(id);
        const Icon = d.icon;
        const active = selected === id;

        return (
          <button
            key={id}
            type="button"
            disabled={disabled}
            onClick={() => onChange(id)}
            className={`relative flex flex-col items-start gap-2 p-3.5 rounded-2xl border-2 text-left transition-all ${
              active
                ? `${d.border} ${d.light} ring-2 ${d.ring} ring-offset-2 shadow-sm`
                : "border-slate-100 bg-white hover:border-slate-200 hover:bg-slate-50"
            } ${disabled ? "opacity-60 cursor-not-allowed" : ""}`}
            data-testid={`discipline-option-${id}`}
          >
            <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${active ? d.color : "bg-slate-100 text-slate-600"}`}>
              <Icon className="w-4.5 h-4.5 w-[18px] h-[18px]" />
            </div>
            <div>
              <p className={`text-sm font-semibold leading-tight ${active ? d.accent : "text-slate-900"}`}>
                {d.shortLabel}
              </p>
              <p className="text-[10px] text-slate-500 mt-0.5 line-clamp-2 leading-snug">{d.description}</p>
            </div>
          </button>
        );
      })}
    </div>
  );
}